"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var TrackOnChange = function (_a) {
    var track = _a.track, trackingMessage = _a.trackingMessage, _b = _a.trackingProps, trackingProps = _b === void 0 ? {} : _b, children = _a.children;
    react_1.useEffect(function () {
        track(trackingMessage, trackingProps);
    }, [track, trackingMessage, trackingProps]);
    return children;
};
exports.default = TrackOnChange;
